import React, { Fragment, useEffect, useRef, useState } from 'react';

// @mui
import { styled } from '@mui/material/styles';
import { Container } from '@mui/material';
// components
import { useDispatch, useSelector } from 'react-redux';
import CarDeliverySection from '../segment/carDeliverySection';
import YoutubeCarousel from '../segment/youtubeCarousal';
import { getAllCategoriesIncludeVehicle } from '../server/api/category';
import Category from '../segment/@common/Category/category';
import Brands from '../segment/@common/Banner/brands';
import FeaturedCars from '../segment/@common/Banner/featuredCars';
// import { useDevice } from '../hooks/useResponsive';
// import Banner from '../segment/@common/Banner/banner';
import { MetaHelmet } from '../layouts/Helmet/Helmet';
import Feature from '../segment/@common/Feature/feature';
// import Youtube from '../segment/@common/Youtube/youtube';
import TestimonialCarousel from '../segment/ReviewCarousal';
import ShowRoomCarousalSection from '../segment/showRoomCarousal';
import CarHistorySection from '../segment/carHistory';
import YoutubeShortsCarousalSection from '../segment/YoutubeShortsCarousal';
import BannerSection from '../segment/BannerSection';
import { getAllTestimonials } from '../server/api/testimonial';
import { getAllShowrooms } from '../server/api/showrooms';
import { getAllCarDelivery } from '../server/api/carDelivery';
import { getAllYoutubeVideos } from '../server/api/youtubeVideos';
import { getAllYoutubeShorts } from '../server/api/youtubeShorts';
import { useDevice } from '../hooks/useResponsive';
import BannerSectionWeb from '../segment/BannerSectionWeb';
import PanIndiaSection from '../segment/panIndiaSection';

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

export default function HomePage() {
  const dispatch = useDispatch();
  const { isMobile } = useDevice();

  const heroImageRef = useRef(null);
  const [heroImageHeight, setHeroImageHeight] = useState(110);

  const {
    categoryList,
    testimonialList,
    showroomsList,
    carDeliveryList,
    youtubeVideosList,
    YoutubeShorts,
    categoryLoading,
  } = useSelector((state) => ({
    categoryList: state.category.categoryIncludeVehicle?.response?.categoryVehicles,
    testimonialList: state.Testimonial.testimonials,
    showroomsList: state.Showroom.showrooms,
    carDeliveryList: state.CarDelivery.deliveries,
    youtubeVideosList: state.YoutubeVideo.youtubeVideos,
    YoutubeShorts: state.YoutubeShorts.shorts,
    categoryLoading: state.category.loading,
  }));
  // console.log('categoryList>>>>>>>>.', categoryList);
  useEffect(() => {
    const credentials = {
      dispatch,
    };
    dispatch(getAllCategoriesIncludeVehicle(credentials));
  }, [dispatch]);

  const updateHeroImageHeight = () => {
    if (heroImageRef.current) {
      setHeroImageHeight(heroImageRef.current.offsetHeight);
    }
  };

  useEffect(() => {
    // Update height on mount in case the image is already loaded
    updateHeroImageHeight();
    // Add a resize listener to update height dynamically
    window.addEventListener('resize', updateHeroImageHeight);
    return () => {
      window.removeEventListener('resize', updateHeroImageHeight);
    };
  }, []);

  useEffect(() => {
    const credentials = {
      page: '',
      search: '',
      limit: '',
      sortBy: '',
      dispatch,
    };
    dispatch(getAllTestimonials(credentials));
  }, [dispatch]);

  useEffect(() => {
    const credentials = {
      page: '',
      search: '',
      limit: '',
      sortBy: '',
      dispatch,
    };
    dispatch(getAllShowrooms(credentials));
  }, [dispatch]);

  useEffect(() => {
    const credentials = {
      page: '',
      search: '',
      limit: '',
      sortBy: '',
      dispatch,
    };
    dispatch(getAllCarDelivery(credentials));
  }, [dispatch]);

  useEffect(() => {
    const credentials = {
      page: '',
      search: '',
      limit: '',
      sortBy: '',
      dispatch,
    };
    dispatch(getAllYoutubeVideos(credentials));
  }, [dispatch]);

  useEffect(() => {
    const credentials = {
      dispatch,
    };
    dispatch(getAllYoutubeShorts(credentials));
  }, [dispatch]);

  // console.log('categoryList?.[0]', categoryList?.[0]);
  return (
    <>
      <MetaHelmet title={'Home'} companyName={'Focus Motors'} />

      <StyledRoot className="bg-color" sx={{ display: !isMobile && 'flex', flexDirection: !isMobile && 'column' }}>
        {!isMobile && <BannerSectionWeb heroImageHeight={heroImageHeight - 12} />}

        <Container className="landgmainsection " maxWidth="xl" sx={{ pb: '0px !important', mt: !isMobile && '80px' }}>
          {/* <Banner /> */}
          {isMobile && <BannerSection heroImageHeight={heroImageHeight - 12} />}
          <FeaturedCars />
          <Brands />
          {categoryList?.[0]?.vehicles?.length > 0 && (
            <Category category={categoryList[0]} categoryLoading={categoryLoading} />
          )}
          {categoryList?.[1]?.vehicles?.length > 0 && (
            <Category category={categoryList[1]} categoryLoading={categoryLoading} />
          )}

          <Feature />
        </Container>
        <div
          style={{
            borderBottom: '1px solid',
            borderImageSource: 'linear-gradient(90deg, #333333 0%, #9E9E9E 49.07%, #333333 100%)',
            borderImageSlice: 1,
            marginBottom: '25px',
          }}
        />
        <Container className="bellow-container-home" maxWidth="xl" sx={{ pb: 7 }}>
          {categoryList?.[2]?.vehicles?.length > 0 && (
            <Category category={categoryList[2]} categoryLoading={categoryLoading} />
          )}
          {categoryList?.[3]?.vehicles?.length > 0 && (
            <Category category={categoryList[3]} categoryLoading={categoryLoading} />
          )}

          {testimonialList?.list?.length > 0 && <TestimonialCarousel testimonialList={testimonialList?.list} />}
          {categoryList?.[4]?.vehicles?.length > 0 && (
            <Category category={categoryList[4]} categoryLoading={categoryLoading} />
          )}
          {categoryList?.[5]?.vehicles?.length > 0 && (
            <Category category={categoryList[5]} categoryLoading={categoryLoading} />
          )}

          {/* <Youtube /> */}
          {/* <YoutubeCarousel /> */}
          {youtubeVideosList?.list?.length > 0 && <YoutubeCarousel youtubeVideosList={youtubeVideosList?.list} />}

          {categoryList?.[6]?.vehicles?.length > 0 && (
            <Category category={categoryList[6]} categoryLoading={categoryLoading} />
          )}
          <CarDeliverySection carDeliveryList={carDeliveryList?.list} />
          {/* {isMobile && <WarrantyCard />} */}
          <PanIndiaSection />

          {showroomsList?.list?.length > 0 && <ShowRoomCarousalSection showroomsList={showroomsList?.list} />}

          <CarHistorySection />

          {YoutubeShorts?.list?.length > 0 && (
            <YoutubeShortsCarousalSection YoutubeShorts={YoutubeShorts?.list} mb="remove-mb" />
          )}
        </Container>
      </StyledRoot>
    </>
  );
}
